export const runAdriverTracking = () => {
  !(function (e, n) {
    function o(e, n, o) {
      n = n || '&'
      o = o || '='
      const d = []
      for (const r in e) {
        if (Object.prototype.hasOwnProperty.call(e, r)) {
          d.push(r + o + encodeURIComponent(e[r]))
        }
      }
      return d.join(n)
    }
    function d(e, n) {
      const o = e.cookie.match('(^|;) ?' + n + '=([^;]*)(;|$)')
      return o ? decodeURIComponent(o[2]) : null
    }
    const r = e
    const t = n
    const i = document.domain
    const c = { tail256: document.referrer || 'unknown' }
    let u
    u = (function (e) {
      const n = {}
      if (e) {
        const o = e.split('&')
        for (const d in o) {
          if (Object.prototype.hasOwnProperty.call(o, d)) {
            const r = o[d].split('=')
            if (r[0] !== undefined && r[1] !== undefined) {
              n[r[0]] = decodeURIComponent(r[1])
            }
          }
        }
      }
      return n
    })(window.location.search.substring(1))
    if (u.adrclid !== undefined) {
      r.fsid = u.adrclid
    }
    if (d(document, 'adrcid') !== null) {
      r.cid = d(document, 'adrcid')
    }
    if (t && t.id && d(document, t.id) !== null) {
      r.suid = i + '_' + encodeURIComponent(d(document, t.id))
    }
    if (t && t.gid1) {
      r.gid1 = t.gid1
    } else if (d(document, '_ga') !== null) {
      r.gid1 = encodeURIComponent(d(document, '_ga'))
    }
    if (t && t.yid1) {
      r.yid1 = t.yid1
    } else if (d(document, '_ym_uid') !== null) {
      r.yid1 = encodeURIComponent(d(document, '_ym_uid'))
    }
    r.loc = encodeURIComponent(window.location.href)
    if (r.custom) {
      r.custom = o(r.custom, ';')
    }
    !(function (e, n) {
      !(function (e) {
        e = e.split('![rnd]').join(~~(1e6 * Math.random()))
        if (document.createElement && document.body) {
          const n = document.createElement('img')
          n.style.position = 'absolute'
          n.style.display = 'none'
          n.style.width = '0px'
          n.style.height = '0px'
          n.setAttribute('referrerpolicy', 'no-referrer-when-downgrade')
          n.src = e
          document.body.appendChild(n)
        } else {
          const o = new Image()
          o.setAttribute('referrerpolicy', 'no-referrer-when-downgrade')
          o.src = e
        }
      })('https://ad.adriver.ru/cgi-bin/rle.cgi?' + e + '&rnd=![rnd]' + (n ? '&' + n : ''))
    })(o(r), o(c))
  })({ sid: 229634, bt: 62 }, { id: '', gid1: '', yid1: '' })
}
